import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { ElMessage } from 'element-plus';
import 'element-plus/es/components/message/style/index'

import { onMounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { checkInviteCode } from '@/request';
const loadingSvg = `
  <path class="path" d="
    M 30 15
    L 28 17
    M 25.61 25.61
    A 15 15, 0, 0, 1, 15 30
    A 15 15, 0, 1, 1, 27.99 7.5
    L 15 15
  " style="stroke: #ffffff; stroke-width: 4px; fill: rgba(0, 0, 0, 0)"/> 
`;
var DeviceType;
(function (DeviceType) {
  DeviceType["PC"] = "pc";
  DeviceType["Mobile"] = "mobile";
  DeviceType["Tablet"] = "tablet"; // 平板电脑
})(DeviceType || (DeviceType = {}));
// 新增方法：检测设备类型
export default /*@__PURE__*/_defineComponent({
  __name: 'LoginOverture',
  setup(__props) {
    const route = useRoute();
    const router = useRouter();
    let loadingManSource = ref(true);
    // https://client.lzwcdm.com/#/regiest-invite?inviteCode=1234
    // 定义设备类型的枚举
    function detectDeviceType() {
      const userAgent = navigator.userAgent.toLowerCase();
      if (/mobile|android|iphone|ipad|ipod/.test(userAgent)) {
        if (/ipad/.test(userAgent)) {
          return 'tablet';
        } else {
          return 'mobile';
        }
      } else {
        return 'pc';
      }
    }
    const devicesGoUrl = {
      pc: {
        development: window.location.origin + '/#/login',
        test: 'http://client-test.lzwcdm.com/#/login',
        production: 'https://client.lzwcdm.com/#/login'
      },
      mobile: {
        development: 'https://192.168.200.38:9000/#/',
        test: 'https://client-app.lzwcdm.com/test/#/',
        production: 'https://client-app.lzwcdm.com/#/'
      },
      tablet: {
        development: 'https://192.168.200.38:9000/#/',
        test: 'https://client-app.lzwcdm.com/test/#/',
        production: 'https://client-app.lzwcdm.com/#/'
      }
    };
    // 调用方法判断 inviteCode 是否有效
    async function isInviteCodeExpired(inviteCode) {
      // 假设有一个 API 可以验证 inviteCode 的有效性
      try {
        let res = await checkInviteCode(inviteCode);
        let {
          code,
          data
        } = res.data;
        return data;
      } catch (error) {
        return false; // 如果出错，假设 inviteCode 已过期
      }
    }
    // 检测当前环境
    function detectEnvironment() {
      const hostname = process.env.NODE_ENV;
      if (hostname.includes("development")) {
        return 'development';
      } else if (hostname.includes('test')) {
        return 'test';
      } else {
        return 'production';
      }
    }
    // 根据设备和环境获取调整后的 URL 地址
    function getAdjustedUrl(deviceType, environment, inviteCode) {
      const baseUrl = devicesGoUrl[deviceType][environment];
      // 如果 inviteCode 为空，则直接返回 baseUrl
      if (!inviteCode) {
        return baseUrl;
      }
      return `${baseUrl}?inviteCode=${inviteCode}`;
    }
    // 工作流方法
    async function workflow() {
      var _route$query;
      let inviteCode = ((_route$query = route.query) === null || _route$query === void 0 ? void 0 : _route$query.inviteCode) || null;
      // 判断当前设备类型
      const deviceType = detectDeviceType();
      // 判断当前环境
      const environment = detectEnvironment();
      // 判断路由中是否有 inviteCode
      if (!inviteCode) {
        // ElMessage.error('未找到邀请代码');
        console.log('未找到邀请代码');
        inviteCode = '';
      }
      const expired = await isInviteCodeExpired(inviteCode);
      if (!expired) {
        ElMessage.error('邀请码已过期');
        console.log('邀请码已过期');
        inviteCode = '';
      }
      // 根据设备和环境获取调整后的 URL 地址
      const adjustedUrl = getAdjustedUrl(deviceType, environment, inviteCode);
      // 收集所有成功信息
      const successMessages = [`当前设备：${deviceType};`, `当前环境：${environment};`, `跳转URL: ${adjustedUrl};`];
      // 一次性展示所有成功信息
      // ElMessage.success(successMessages.join('\n'));
      console.log('successMessages', successMessages.join('\n'));
      // 跳转到 adjustedUrl
      window.location.href = adjustedUrl;
    }
    // 在组件挂载时运行工作流
    onMounted(() => {
      workflow();
    });
    return (_ctx, _cache) => {
      const _directive_loading = _resolveDirective("loading");
      return _withDirectives((_openBlock(), _createElementBlock("div", {
        class: "login-after",
        spinner: 'loading-spinner',
        "element-loading-svg": loadingSvg,
        "element-loading-text": "请稍候...",
        "element-loading-background": "rgba(0, 0, 0, 0)",
        "element-loading-svg-view-box": "-10, -10, 50, 50"
      }, null, 512)), [[_directive_loading, _unref(loadingManSource)]]);
    };
  }
});